import { render, staticRenderFns } from "./InspectionListAlfaberries.vue?vue&type=template&id=bad9556e&"
import script from "./InspectionListAlfaberries.vue?vue&type=script&lang=js&"
export * from "./InspectionListAlfaberries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports